



















































































import {Vue, Component, Watch} from 'vue-property-decorator';
import BrainContainer2d from './brain-container-2d/brain-container-2d.vue';
import GraphTransition from './graph-transition.vue';
import Graph3dContainer from './graph-3d-container.vue';
import DetailStore from '@/store/DetailStore';
import TopHeader from '../top-header/top-header.vue';
import envConfig from '../../../config/env-config.js';
import qsObj from '../../utils/qs';
import qs from 'qs';

type viewType = '2d' | '3d' | 'transition';
let view = qsObj.view;
if (!view) {
    console.log('手动设置：view ' + view);
    view = '3d';
}
let viewArr = ['2d', '3d', 'transition'];

@Component({
    // components: { Graph3dContainer, TopHeader, GraphTransition, Graph2dContainer, MainContainer }
    components: { Graph3dContainer, TopHeader, GraphTransition, BrainContainer2d }
})
export default class FoodContainer extends Vue {
    isPublic = envConfig.isPublic;
    searchObj = {};
    showView: viewType[] = [view];
    // showOpacityView: viewType[] = ['2d'];
    showOpacityView: viewType[] = [];
    detailData = DetailStore.state;
    mode: string = '';
    showMode: boolean = false;
    showModeTimeoutId: any = null;

    get loading() {return this.detailData.loading}

    getContainer (container: viewType) {
        let containerMap = {
            '3d': () => this.$refs.container3d['$el'],
            'transition': () => this.$refs.containerTransition['$el'],
            '2d': () => this.$refs.container2d,
        };
        return containerMap[container]();
    }

    created () {
        if (qsObj.s) {
            this.showView = ['2d'];
            this.showOpacityView = [];
        }
    }

    async changeView (from, to) {
        this.showOpacityView = [from, to]; // 都设置为透明
        this.showView = [from, to]; // 显示出来两个都需要展示的容器
        await this.$sleep(0); // 给DOM渲染的时间 即模拟nextTick 否则下面取不到DOM的
        await this.$onNativeOnce(this.getContainer(from)); // 监听最终展示容器的动画
        this.showOpacityView = []; // 动画开始
        this.showView = [to]; // 只显示最后需要的容器
        await this.$sleep(0); // fake nextTick
    }
    beforeDestroy() {
        document.body.onkeydown = null;
    }

    mounted () {
        // 全局的view切换
        this.$autoOn('view-change', async (from, to, isQuick = false) => {
            // 没办法了最后尝试刷新页面行不行
            if (to === '3d') {
                location.reload();
            }
            await this.changeView(from, to);
            // TODO 参数合并
            if (isQuick) {
                await this.$bus.$emit(to+'-start', true); // isQuick 理论上 只会有 2d-start 会有quick的参数
            } else {
                await this.$bus.$emit(to+'-start'); // transition-start 2d-start TODO 3d-start
            }
        });

        // if (!sessionStorage.getItem('mode')) {
        //     sessionStorage.setItem('mode', this.mode);
        // }

        let tmp;
        document.body.onkeydown = (ev) => {
            // this.changeMode = false;
            if (ev.target && (ev.target as any).tagName && (ev.target as any).tagName.toLowerCase() === 'input') {
                return
            }

            const key = ev.key.toLowerCase();

            if (key === 'c') {
                tmp = key;
            } else {
                tmp += key;
            }

            if (tmp === 'ca' || tmp === 'cb') {
                let queryString = location.search.slice(1);
                let queryObj = qs.parse(queryString);

                if (tmp === 'ca') {
                    if (queryObj.auto) {
                        queryObj.auto = undefined;
                    } else {
                        queryObj.auto = 1;
                    }
                }

                if (tmp === 'cb') {
                    if (queryObj.goto) {
                        queryObj.goto = undefined;
                    } else {
                        queryObj.goto = 1;
                    }
                }

                queryString = qs.stringify(queryObj);
                location.search = queryString ? '?' + queryString : '';
            }

            if (tmp === 'cg') {
                location.pathname = 'case';
            }

            if (tmp === 'cv') {
                const queryObj = qs.parse(location.search.slice(1));
                this.showMode = true;
                this.mode = `自动轮播：${queryObj.auto ? '开启' : '关闭'}，跳转系统：${queryObj.goto ? '开启' : '关闭'}`;

                clearTimeout(this.showModeTimeoutId);
                this.showModeTimeoutId = setTimeout(() => {
                   this.showMode = false;
                }, 1000);
            }


            // 继续播放
            if (tmp === 'ck') {
                // this.changeMode = true;
                // this.mode = this.mode === 'speaker' ? 'auto' : 'speaker'; // 切换模式
                // sessionStorage.setItem('mode', this.mode);
                this.$bus.$emit('action-script-start');
            }
        };
    }
}
